import { authClient } from '~~/layers/base/lib/auth-client'
import { ensureGuestBetterAuthSession } from '~~/layers/base/utils/ensureGuestBetterAuthSession'
import {
    runLeaveEcommerceDesignerBetterAuthResync,
    syncPreservedBetterAuthSessionFromClientData,
} from '~~/layers/base/utils/ecommerceDesignerBetterAuthInjunction'
import { isEcommerceDesignerRoute } from '~~/layers/base/utils/isEcommerceDesignerRoute'

/**
 * TK-13530 temporary injunction: preserves Better Auth session snapshots on purchase-designer
 * routes (so focus refetch stubs do not wipe the global store), and restores Better Auth after
 * leaving ecommerce designer (Magento/ACCS only today). Remove when purchase paths use Better Auth.
 */
export default defineNuxtPlugin(() => {
    const route = useRoute()
    const datadog = useDatadog()
    const session = authClient.useSession()

    watch(
        [() => route.fullPath, () => session.value?.data],
        () => {
            if (!isEcommerceDesignerRoute(route)) {
                return
            }
            syncPreservedBetterAuthSessionFromClientData(
                session.value?.data as { session?: unknown; user?: { id?: string } | null }
            )
        },
        { immediate: true, deep: true }
    )

    watch(
        () => route.fullPath,
        (_path, previousPath) => {
            if (!previousPath) {
                return
            }
            const wasEcommerceDesigner = isEcommerceDesignerRoute({
                path: previousPath.split('?')[0],
            })
            if (!wasEcommerceDesigner || isEcommerceDesignerRoute(route)) {
                return
            }

            runLeaveEcommerceDesignerBetterAuthResync(async () => {
                try {
                    await ensureGuestBetterAuthSession(datadog)
                    await session.refetch?.()
                } catch (error) {
                    const err = error instanceof Error ? error : new Error(String(error))
                    datadog.logError(err, {
                        feature: 'better-auth',
                        action: 'resume-after-ecommerce-designer',
                    })
                }
            })
        }
    )
})
